import { useState } from 'react';
import { faqList } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8 xl:px-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              FAQ
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
              常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              关于档案怎么整理、内容会不会更新、按人物索引怎么查，这里一次说清。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-customer-service-2-line text-xl" />
              </span>
              <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">
                还有别的问题？
              </h3>
              <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                编辑组会定期汇总读者疑问，也欢迎你直接提交线索或更正材料。
              </p>
              <button
                type="button"
                className="mt-4 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 font-label text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-mail-send-line text-base" />
                联系编辑组
              </button>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="rounded-lg border border-background-200 bg-background-100">
              {faqList.map((item, index) => {
                const isOpen = openIndex === index;
                return (
                  <li
                    key={item.q}
                    className="border-b border-background-200/80 last:border-b-0"
                  >
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                      >
                        <span className="font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                        <span
                          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors ${
                            isOpen
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          <i className={isOpen ? 'ri-subtract-line text-base' : 'ri-add-line text-base'} />
                        </span>
                      </button>
                    </h3>
                    {isOpen ? (
                      <div className="px-5 pb-5 md:px-6 md:pb-6">
                        <p className="border-l-2 border-primary-200 pl-4 text-sm leading-relaxed text-foreground-600">
                          {item.a}
                        </p>
                      </div>
                    ) : null}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}